import { useState } from "react";
import { api } from "../lib/api.ts";

export function Login({ onDone }: { onDone: () => void }) {
  const [pass, setPass] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  return (
    <div className="min-h-dvh grid place-items-center p-6">
      <form
        className="grid gap-4 w-full max-w-[22rem]"
        onSubmit={async (e) => {
          e.preventDefault();
          setBusy(true);
          setError(null);
          try {
            await api("/login", { method: "POST", body: { passphrase: pass } });
            onDone();
          } catch (err) {
            setError((err as Error).message === "Wrong passphrase" ? "That passphrase isn't right." : (err as Error).message);
          } finally {
            setBusy(false);
          }
        }}
      >
        <span className="wordmark text-[31px]">Hammer</span>
        <label className="grid">
          <span className="label">Passphrase</span>
          <input className="field" type="password" autoComplete="current-password" autoFocus value={pass} onChange={(e) => setPass(e.target.value)} />
        </label>
        {error && <p className="text-red text-[14px]">{error}</p>}
        <button className="btn btn-primary" disabled={busy || !pass}>{busy ? "Signing in…" : "Sign in"}</button>
      </form>
    </div>
  );
}

/** Shown on a public deployment until the owner sets a passphrase. No data is served until then. */
export function Setup() {
  return (
    <div className="min-h-dvh grid place-items-center p-6">
      <div className="grid gap-4 max-w-[34rem]">
        <span className="wordmark text-[31px]">Hammer</span>
        <h1 className="heading text-[21.6px]">Set a passphrase to finish setup</h1>
        <p>Hammer is running, but it won't show or accept any data until it has a passphrase, so nobody else can use it.</p>
        <ol className="list-decimal pl-5 grid gap-1.5">
          <li>Open the Cloudflare dashboard, then Workers &amp; Pages, then <strong>auctiontracker</strong>.</li>
          <li>Go to Settings, then Variables and secrets, and add a secret named <code className="num">HAMMER_PASSPHRASE</code>.</li>
          <li>Reload this page and sign in with it.</li>
        </ol>
      </div>
    </div>
  );
}
